import React from 'react';
import earthIcon from '../assets/img/earth-svg.svg';
import moneyIcon from '../assets/img/money-svg.svg';
import instrumentsIcon from '../assets/img/instruments-svg.svg';
import mindIcon from '../assets/img/mind-svg.svg';
import "../assets/css/footer.css"
import footerBg from '../assets/img/footer_pattern.jpg';
import { useTranslation } from 'react-i18next';

function Footer() {
    const [t, i18n] = useTranslation("global");

    return (
        <footer className="footer">
            {/* ─────────── Order Block ─────────── */}
            <section className="order-block">
                <div className="order-container">
                <div className="order-header">
                    <h2 className="order-title">{t("footer.title")}</h2>
                    <p className="order-desc">{t("footer.description")}</p>
                </div>

                <div className="order-actions">
                    <a href="/communication" className="order-btn">
                        {t("footer.button_name")}
                    </a>

                    <div className="order-icons">
                        <div className="order-icon">
                            <img src={earthIcon} alt="" />
                            <span>{t("footer.list1")}</span>
                        </div>
                        <div className="order-icon">
                            <img src={moneyIcon} alt="" />
                            <span>{t("footer.list2")}</span>
                        </div>
                        <div className="order-icon">
                            <img src={instrumentsIcon} alt="" />
                            <span>{t("footer.list3")}</span>
                        </div>
                        <div className="order-icon">
                            <img src={mindIcon} alt="" />
                            <span>{t("footer.list4")}</span>
                        </div>
                    </div>
                </div>
                </div>
            </section>

            <div className="footer-main">
                <div className="footer-container">
                {/* ─ About & Socials ─ */}
                <div className="footer-section footer-about-socials">
                    <div className="footer-company">
                    <h3 className="company-title">HAMMERSTONE</h3>
                    <p className="company-desc">{t("footer.company_description")}</p>
                    </div>
                    <div className="footer-socials">
                    <h4 className="socials-title">{t("footer.socials")}</h4>
                    <a className="social-link" href="https://www.instagram.com/hammerstone.ua?igsh=MWcwYzI4YjZnd3VjdA==" target="_blank" rel="noopener noreferrer">Instagram</a>
                    <a className="social-link" href="https://www.facebook.com/share/1B3sRUfyHP/" target="_blank" rel="noopener noreferrer">Facebook</a>
                    </div>
                </div>

                {/* divider line */}
                <div className="footer-divider" />

                {/* ─ Legal & Links ─ */}
                <div className="footer-section footer-legal">
                    <span className="legal-text">{t("footer.rules")}</span>
                    <a className="legal-link" href="/privacy-policy">{t("footer.privacy")}</a>
                    <a className="legal-link" href="/terms-and-conditions">{t("footer.terms")}</a>
                </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;